var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-right"},_vm._l((_vm.GET_TAGLIST),function(tag){return _c('el-tag',{key:tag.path,class:[
      'tag',
      _vm.GET_ACTIVATE.split('?')[0] == tag.path.split('?')[0] ? 'current' : '',
    ],attrs:{"closable":"","disable-transitions":false,"size":"medium"},on:{"close":function($event){return _vm.deleteTags(tag.path)},"click":function($event){return _vm.btn(tag)}}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }